import type { DashboardPayload, HodOverviewResponse } from '@lms/shared-types'
import { hodOverviewResponseSchema } from '@lms/shared-types'
import { apiRequest } from './client'

export interface DashboardQuery {
  team?: string | undefined
  horizonDays?: number | undefined
  fromDate?: string | undefined
  toDate?: string | undefined
  weekStart?: string | undefined
}

export function getDashboard(query: DashboardQuery = {}): Promise<DashboardPayload> {
  const params = new URLSearchParams()
  if (query.team) params.set('team', query.team)
  if (query.horizonDays != null) params.set('horizonDays', String(query.horizonDays))
  if (query.fromDate) params.set('fromDate', query.fromDate)
  if (query.toDate) params.set('toDate', query.toDate)
  if (query.weekStart) params.set('weekStart', query.weekStart)
  const qs = params.toString()
  return apiRequest<DashboardPayload>(`/api/v1/dashboard${qs ? `?${qs}` : ''}`)
}

export interface HodOverviewQuery {
  weeks?: number
}

export async function getHodOverview(query: HodOverviewQuery = {}): Promise<HodOverviewResponse> {
  const params = new URLSearchParams()
  if (query.weeks != null) params.set('weeks', String(query.weeks))
  const qs = params.toString()
  const raw = await apiRequest<unknown>(`/api/v1/hod/overview${qs ? `?${qs}` : ''}`)
  return hodOverviewResponseSchema.parse(raw)
}

export async function resolveHodEscalation(escalationId: string): Promise<void> {
  await apiRequest<unknown>(
    `/api/v1/hod/escalations/${encodeURIComponent(escalationId)}/resolve`,
    { method: 'POST' },
  )
}

export async function declineHodEscalation(escalationId: string): Promise<void> {
  await apiRequest<unknown>(
    `/api/v1/hod/escalations/${encodeURIComponent(escalationId)}/decline`,
    { method: 'POST' },
  )
}
